import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnInit,
} from '@angular/core';
import {OVERLAY_PANEL_DATA} from '@common/core/ui/overlay-panel/overlay-panel-data';
import {PermissionBtnConfig} from '../permission-aware-button/permission-aware-button.component';
import { simplePermissionOverlayMsg } from './simple-permission-overlay-message';

@Component({
    selector: 'simple-permission-overlay',
    templateUrl: './simple-permission-overlay.component.html',
    styleUrls: ['./simple-permission-overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {class: 'permission-overlay'},
})
export class SimplePermissionOverlayComponent implements OnInit {
    public message: string;
    constructor(
        @Inject(OVERLAY_PANEL_DATA) public data: {config: PermissionBtnConfig}
    ) {}

    ngOnInit(): void {
        this.message = simplePermissionOverlayMsg(
            this.data.config.resource,
            this.data.config.forWorkspace,
            this.data.config.action,
            this.data.config.createMsgType
        );
    }
}
